import Select from 'react-select'
import { AdjustmentsHorizontalIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'libs/i18n'

import Control from './Control'
import { menuClassNames } from '../classNames'
import { WithClassName } from 'shared/types/general.types'
import { cn } from 'utils/style'

interface ISortOption {
	value: string
	label: string
}

type ISortSelect = WithClassName<{
	id: string
	options: ISortOption[]
	onChange: (data: any) => void
}>

export const SortSelect = ({ options, className, onChange }: ISortSelect) => {
	const { t } = useTranslation()

	const handleSort = (data: any) => {
		onChange({ id: 'ordering', ...data })
	}

	return (
		<Select
			className={cn('relative', className)}
			classNames={menuClassNames}
			options={options}
			isSearchable={false}
			components={{
				IndicatorSeparator: () => null,
				Control: ({ ...rest }) => (
					<Control {...rest} icon={<AdjustmentsHorizontalIcon />} label={t('Sort')} />
				)
			}}
			onChange={handleSort}
		/>
	)
}
